import React, { useEffect, useRef } from 'react';
import { Carousel, Container, Row, Col } from 'react-bootstrap';
import IMAGES from '../assets/index.js';

function Banner() {
  const bannerRef = useRef(null);
  
  // Effect to adjust banner height based on viewport
  useEffect(() => {
    const adjustBannerHeight = () => {
      const banner = bannerRef.current;
      if (!banner) return;
      
      // For large screens, set height to full viewport minus header
      if (window.innerWidth >= 1600) {
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
        banner.style.minHeight = `calc(100vh - ${headerHeight}px)`;
        banner.style.marginTop = '100px';
        banner.style.flexDirection = 'column';
        banner.style.justifyContent = 'center';
      } else {
        // For smaller screens, allow natural height
        banner.style.minHeight = '650px';
      }
    };
    
    // Adjust on mount and resize
    adjustBannerHeight();
    window.addEventListener('resize', adjustBannerHeight);
    
    return () => {
      window.removeEventListener('resize', adjustBannerHeight);
    };
  }, []);

  // Custom navigation buttons with correct positioning
  const customPrevIcon = (
    <div className="carousel-control-btn">
      <i className="fa fa-arrow-left" aria-hidden="true"></i>
    </div>
  );
  
  const customNextIcon = (
    <div className="carousel-control-btn">
      <i className="fa fa-arrow-right" aria-hidden="true"></i>
    </div>
  );

  // Style for the span elements with right padding
  const subtitleStyle = {
    paddingRight: "20px",
    display: "inline-block",
    textAlign: "left",
    marginBottom: "5px"
  };

  return (
    <section 
      ref={bannerRef}
      className="banner_main" 
      style={{ 
        backgroundColor: 'transparent',
        paddingTop: '50px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Particle background is now handled at App level */}
      
      <Carousel 
        id="myCarousel" 
        className="banner"
        controls={true}
        indicators={false} // Set to false to hide the indicators
        prevIcon={customPrevIcon}
        nextIcon={customNextIcon}
      >
        <Carousel.Item>
          <Container className="d-flex justify-content-center">
            <Row className="banner-row align-items-center justify-content-center w-100">
              <Col md={3} className="text-center d-flex justify-content-center">
                <div className="yo_img">
                  <figure><img src={IMAGES.yogaImg} alt="#" /></figure>
                </div>
              </Col>
              <Col md={9} className="text-center">
                <div className="yoga_box">
                  <span>Now started</span>
                  <h1><strong>Y</strong>O<strong>G</strong>A</h1>
                  <a 
                    className="read_more_head yoga_btn_head" 
                    href="#contact"
                  >
                    Contact us
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
        
        <Carousel.Item>
          <Container className="d-flex justify-content-center">
            <Row className="banner-row align-items-center justify-content-center w-100">
              <Col md={3} className="text-center d-flex justify-content-center">
                <div className="yo_img">
                  <figure><img src={IMAGES.yogaImg} alt="#" /></figure>
                </div>
              </Col>
              <Col md={9} className="text-center">
                <div className="yoga_box">
                  <span style={subtitleStyle}>Maintain</span>
                  <h1><strong>HE</strong>AL<strong>T</strong>H</h1>
                  <a 
                    className="read_more_head yoga_btn_head" 
                    href="#classes"
                  >
                    Our Classes
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
        
        <Carousel.Item>
          <Container className="d-flex justify-content-center">
            <Row className="banner-row align-items-center justify-content-center w-100">
              <Col md={3} className="text-center d-flex justify-content-center">
                <div className="yo_img">
                  <figure><img src={IMAGES.yogaImg} alt="#" /></figure>
                </div>
              </Col>
              <Col md={9} className="text-center">
                <div className="yoga_box">
                  <span style={subtitleStyle}>Relieve</span>
                  <h1><strong>ST</strong>RE<strong>S</strong>S</h1>
                  <a 
                    className="read_more_head yoga_btn_head" 
                    href="#pictures"
                  >
                    Our Culture
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
      </Carousel>
    </section>
  );
}

export default Banner;
